import { TrackingToolsToTable } from "components/Tables/TrackingToolsToTable/TrackingToolsToTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getToolTrackingHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/"
)({
    component: TrackingToolsToPage,
    staticData: {
        permissions: [PermissionEnum.ToolTrackingOutgoing],
        showInSideMenu: false,
        label: "pages.tool.tracking.to.title",
    },
    loader: ({ context: { t } }) => {
        return { breadcrumb: t("pages.tool.tracking.to.title") };
    },
});

function TrackingToolsToPage() {
    return (
        <TenantPage headerNavigationItems={getToolTrackingHeaderItems}>
            <TrackingToolsToTable />
        </TenantPage>
    );
}
